import { logger } from "@/utils/logger"

export async function loadExternalScriptWithCookies(
	url: string,
): Promise<void> {
	// avoid duplicates
	if (document.querySelector(`script[id="${url}"]`)) {
		return
	}

	try {
		const response = await fetch(url, { credentials: "include" })
		if (!response.ok) {
			throw new Error(`Failed to load script: ${url}`)
		}

		const scriptText = await response.text()
		const script = document.createElement("script")
		script.textContent = scriptText
		script.id = url
		document.body.appendChild(script)
		logger.info(`Script loaded successfully: ${url}`)
	} catch (error) {
		console.error(`Failed to load script: ${url}`, error)
	}
}
